import { Link } from "react-router-dom";
import SubscriptionPromo from "../components/SubscriptionPromo";

export default function Home() {
  return (
    <>
      <section className="hero">
        <div className="shell hero-inner">
          <div>
            <p className="eyebrow">PRIVATE MOBILE TAILORING · KANSAS CITY</p>
            <h1>Exceptional<br />Tailoring.<br /><em>Delivered to You.</em></h1>
            <p className="lead">Precision alterations and private fittings at your home, office, or agreed location. Serving greater Kansas City with 25 years of tailoring experience.</p>
            <div className="actions">
              <Link className="button gold" to="/booking" data-testid="hero-book-btn">Schedule Your Fitting</Link>
              <Link className="button outline-light" to="/pricing" data-testid="hero-pricing-btn">View Alteration Pricing</Link>
            </div>
            <p className="hero-meta">Established 2008 · Mobile by appointment · Blue Springs, Missouri</p>
          </div>
          <div className="hero-art" aria-hidden="true">
            <div className="art-frame">
              <div className="needle">✦</div>
              <div className="art-title">THE ART OF<br />A PERFECT FIT</div>
              <div className="art-rule" />
              <div className="art-caption">CRAFT · PRECISION · CONVENIENCE</div>
            </div>
          </div>
        </div>
      </section>
      <main className="shell">
        <div className="statline" data-testid="statline">
          <div><strong>25 Years</strong><span>Tailoring experience</span></div>
          <div><strong>Mobile</strong><span>We come to you</span></div>
          <div><strong>Personal</strong><span>One-on-one fittings</span></div>
        </div>
        <section className="section">
          <p className="eyebrow">THE TAILOR INC. EXPERIENCE</p>
          <h2>Tailoring that fits your life.</h2>
          <div className="three">
            <article className="feature"><b>01</b><h3>Book online</h3><p>Choose an available date and time and pay your $100 fitting reservation securely.</p></article>
            <article className="feature"><b>02</b><h3>We come to you</h3><p>Meet your tailor at home, at the office, or another agreed location within our service area.</p></article>
            <article className="feature"><b>03</b><h3>Wear the difference</h3><p>Receive a clear alteration estimate before work begins. Garment return or delivery is arranged with you.</p></article>
          </div>
        </section>
        <SubscriptionPromo />
        <section className="section split">
          <div>
            <p className="eyebrow">APPOINTMENTS MADE SIMPLE</p>
            <h2>Your fitting, on your schedule.</h2>
            <p>Standard appointments are available Monday and Tuesday, 10 AM–5 PM, and Saturday, 10 AM–3 PM. After-hours appointments can be requested Monday and Tuesday, 5–8 PM, subject to approval.</p>
            <Link className="button dark" to="/booking" data-testid="split-book-btn">View Available Appointments</Link>
          </div>
          <div className="info-panel">
            <h3>Private Mobile Fitting</h3>
            <div className="display-price">$100</div>
            <p>60-minute fitting reservation, credited toward eligible alteration work.</p>
            <hr />
            <h3>After-Hours Request</h3>
            <div className="display-price">$150</div>
            <p>Includes the $100 fitting credit plus a $50 noncreditable convenience fee. Approval required before payment.</p>
          </div>
        </section>
        <section className="section center">
          <p className="eyebrow">WHERE WE SERVE</p>
          <h2>Greater Kansas City, at your convenience.</h2>
          <p>Blue Springs · Independence · Lee’s Summit · Kansas City · Overland Park · Leawood · Olathe</p>
          <p className="fine">Service location and any applicable travel fee are confirmed before the appointment.</p>
        </section>
      </main>
    </>
  );
}
